import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import CustomDate from '../CustomDate';
import messages from './messages';
import { styles } from './styles';

interface INextConsumptionProps {
  licencesPool?: number;
  multiplier: number;
  requirePaymentCount: number;
  validityTo: string;
}

export function NextConsumption({ licencesPool, multiplier = 1, requirePaymentCount = 0, validityTo = "" }: INextConsumptionProps) {
  const finalPayment = requirePaymentCount * multiplier;

  return (licencesPool !== undefined
    && licencesPool > 0 && finalPayment > 0 && licencesPool >= finalPayment)
    ? (
      <Typography sx={styles.text} variant="body2">
        <FormattedMessage
          values={{
            date: <CustomDate dateValue={validityTo} />,
            span: (chunks: React.ReactNode) => (
              <Box component="span" sx={styles.number}>
                {chunks}
              </Box>
            ),
            text: (chunks: React.ReactNode) => (
              <Box component="span" sx={styles.textColor}>
                {chunks}
              </Box>
            ),
          }}
          {...messages.creditPoolCardNextConsumptionDate}
        />
      </Typography>
    )
    : null;
}
